export const appGroupIdCanvasesForUco = "/engagement/canvases_for_uco";
